import React from 'react';
import './WhyChoose.css';

function WhyChoose() {
  const features = [
    {
      icon: '/icons/clock.png',
      title: 'Unmatched Speed in B2B Lending',
      description: 'Receive preliminary approval within 48 hours and the final credit decision in 5-7 business days. Keep your supply chain moving no lengthy waiting periods.'
    },
    {
      icon: '/icons/checkmark.png',
      title: 'Institutional Security',
      description: 'We use bank-level 256-bit SSL encryption and SOC Type certified infrastructure. Your proprietary financial data is protected at every step.'
    },
    {
      icon: '/icons/shield.png',
      title: 'Custom-Fit Credit Line',
      description: 'Access credit lines from ₹30,000 To ₹25 Lakh with flexible, customizable repayment terms. Competitive rates are precisely tailored to your unique business profile and cash flow.'
    }
  ];

  return (
    <section className="why-choose">
      <div className="why-choose-container">
        <h2 className="heading-lg text-center">Why choose Credit<span style={{ color: '#2B8F47' }}>Hai</span>.com ?</h2>
        <p className="body-md text-center">
          Enterprise-grade financing solutions designed for modern business
        </p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="card feature-card">
              <img src={feature.icon} alt={feature.title} className="feature-icon" />
              <h3 className="heading-sm">{feature.title}</h3>
              <p className="caption-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChoose;